<template>
  <div class="container-fluid">
    <transition name="fade-delay-2" mode="out-in">
      <modal v-if="isMediaSelected" class="z-9250" />
    </transition>
    <transition name="fade" mode="out-in">
      <modal v-if="isLoading" class="z-9999">
        <loader scale="3" color="white" />
      </modal>
    </transition>
    <vue-dropzone
      :key="'media' + media.length"
      ref="myVueDropzone"
      id="dropzone"
      :options="dropzoneOptions"
      :destroy-dropzone="false"
      @vdropzone-mounted="dropMounted"
      @vdropzone-sending="dropSending"
      @vdropzone-removed-file="dropRemove"
      @vdropzone-success="dropSuccess"
      :include-styling="true"
      v-on:vdropzone-thumbnail="thumbnail"
      :useCustomSlot="true"
      class="row"
    >
      <div
        v-for="(placeholder, index) in placeHolderQuantity"
        :key="index"
        class="dz-message d-flex align-items-center justify-content-center py-3 px-2 pointer-events-none"
      >
        <div
          class="dropzone-custom-content d-flex flex-column align-items-center justify-content-center"
        >
          <img
            src="@/assets/images/icons/plus.svg"
            height="18"
            alt="Add media"
            class="mb-2"
          />
          <h3 v-if="collectionDBname == 'videos'" class="m-0">Nuevo video</h3>
          <h3 v-if="collectionDBname == 'photos'" class="m-0">Nueva foto</h3>
        </div>
      </div>
      <div
        class="dz-message d-flex align-items-center justify-content-center pointer-events-none"
      >
        <div
          class="dropzone-custom-content d-flex flex-column align-items-center justify-content-center py-3 px-2"
        >
          <img
            src="@/assets/images/icons/plus.svg"
            height="18"
            alt="Add media"
            class="mb-2"
          />
          <h3 v-if="collectionDBname == 'videos'" class="m-0">Nuevo video</h3>
          <h3 v-if="collectionDBname == 'photos'" class="m-0">Nueva foto</h3>
        </div>
      </div>
    </vue-dropzone>
    <transition name="fade" mode="out-in">
      <div
        v-if="isMediaSelected"
        class="z-9500 container-fluid position-fixed bg-white h-85 validation overflow-auto"
        v-click-outside="swipeHandler"
      >
        <div class="row">
          <div v-touch:swipe.bottom="swipeHandler" class="row py-4">
            <img
              src="@/assets/images/icons/swipe-horizontal.svg"
              height="6"
              alt="Swipe down to close"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center">
            <h3 class="text-rem-1-5 text-dark">Qué deseas hacer</h3>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12 d-flex justify-content-center">
            <img
              v-if="selectedMedia.type == 'image/jpg'"
              :src="`https://69prepagos.com/${selectedMedia.name}_360@2x.jpg`"
              height="190"
              alt="Imagen en edición"
            />
            <img
              v-else-if="selectedMedia.type == 'video/mp4'"
              :src="
                `https://videodelivery.net/${selectedMedia.name}/thumbnails/thumbnail.jpg?width=200&height=150`
              "
              height="150"
              alt="Imagen en edición"
            />
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-10">
            <button @click="dropDelete" :class="'outlined-grey mt-4'">
              Eliminar
            </button>
            <button
              v-if="
                !selectedMedia.listing && selectedMedia.type !== 'video/mp4'
              "
              @click="toggleListing"
              :class="'outlined-grey my-4'"
            >
              Poner de portada
            </button>
          </div>
        </div>
        <!-- <div class="row">
          <button class="bg-alert" @click="validateCode">VALIDATE CODE</button>
        </div> -->
      </div>
    </transition>
  </div>
</template>
<script>
import Modal from "@/components/UI/Partials/Modal.vue"

import ClickOutside from "vue-click-outside"
import Loader from "@/components/UI/Loader.vue"
import vue2Dropzone from "vue2-dropzone"
import "vue2-dropzone/dist/vue2Dropzone.min.css"
import axios from "axios"
import settings from "../../api/settings"
import { mapActions } from "vuex"
export default {
  props: ["media", "objectId", "collectionDBname", "photos", "name"],
  methods: {
    ...mapActions([
      "FETCH_photos",
      "SET_LISTING_PHOTO",
      "DELETE_photos",
      "FETCH_videos",
      "INIT_APP",
      "DELETE_videos",
    ]),
    disable() {
      this.$refs.myVueDropzone.disable()
    },
    toggleListing() {
      this.isLoading = true
      console.log("entre a toggel listing")
      this.SET_LISTING_PHOTO(this.selectedMedia._id).then(status => {
        if (status) {
          this["FETCH_" + this.$route.params.param0]().then(() => {
            this["INIT_APP"]().then(() => {
              this.populateDropZone()
              this.isLoading = false
              return true
            })
          })
        }
      })
    },
    swipeHandler() {
      this.isMediaSelected = false
      this["FETCH_" + this.$route.params.param0]().then(status => {
        console.log(status)
        this.populateDropZone()
      })
    },
    populateDropZone() {
      this.$refs.myVueDropzone.removeAllFiles()
      if (this.media.length > 0) {
        this.media.map(m => {
          console.log("DENTRO DE MEDIA MAp", m)
          let file = {
            size: 123,
            name: m.id,
            type: !m.width ? "video/mp4" : "image/jpg",
            listing: m.listing,
            _id: m._id,
          }

          //let url = `https://www.wseedsolutions.com/klausMarket/${m.id}_o.jpg`
          let url
          if (file.type == "image/jpg") {
            url = `https://69prepagos.com/${m.id}_360@2x.jpg`
          } else {
            url = `https://videodelivery.net/${m.id}/thumbnails/thumbnail.jpg?width=200&height=150`
          }
          console.log(url, m)
          this.$refs.myVueDropzone.manuallyAddFile(file, url)
        })

        this.isMediaSelected = false
      }
    },
    dropSending(file, xhr, formData) {
      this.isLoading = true
      console.log(
        "dropSending",
        file,
        xhr,
        formData,
        this.dropzoneSettings.api_key
      )
      formData.append("api_key", this.dropzoneSettings.api_key)
      formData.append("timestamp", (Date.now() / 1000) | 0)
      formData.append("upload_preset", this.dropzoneSettings.upload_preset)
    },
    async dropRemove(file, error, xhr) {
      console.log("dropRemove", file, error, xhr)
      this.isMediaSelected = true
      this.selectedMedia = file
      /* await axios
        .post(
          "/deleteDZ/dashboard/" + this.collectionDBname + "/" + this.objectId,
          {
            id: file.name,
            objectId: this.objectId,
          }
        )
        .then(() => {
          return true
        }) */
    },
    async dropDelete() {
      this.isMediaSelected = false
      this.isLoading = true

      console.log("dropDELETE")
      /* this.$store.dispatch(`DELETE_${this.$route.params.param0}`) */
      this["DELETE_" + this.$route.params.param0](this.selectedMedia._id).then(
        () => {
          this["FETCH_" + this.$route.params.param0]().then(status => {
            console.log(status)
            this.populateDropZone()
            this.isLoading = false
          })
        }
      )
    },
    async dropSuccess(file, response) {
      console.log("dropSuccess", file, response)

      const { /*url,*/ version, width, height } = response
      const key = response.public_id
      //bug fix
      //file.append("name", key)
      /*const responseFromServer = */ await axios
        .post(
          "/uploadDZ/dashboard/" + this.collectionDBname + "/" + this.objectId,
          {
            key,
            width,
            height,
            version,
            objectId: this.objectId,
          }
        )
        .then(() => {
          this["FETCH_" + this.$route.params.param0]().then(status => {
            console.log(status)
            this.populateDropZone()
            this.isLoading = false
          })
        })
    },
    dropMounted() {
      this.populateDropZone()
    },
    template: function() {
      /*  <div class="dz-details">

                    <div class="dz-size"><span data-dz-size></span></div>
                    <div class="dz-filename"><span data-dz-name></span></div>
                </div> */
      return `<div class="dz-preview dz-file-preview col-4 media-gutters">

                <div class="dz-image">
                    <div data-dz-thumbnail-bg>
                    <div class="dz-listing poppins-medium" data-dz-listing>Portada</div>
                    </div>
                </div>

                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                <div class="dz-error-message"><span data-dz-errormessage></span></div>
                <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                <div class="dz-error-mark"><i class="fa fa-close"></i></div>
            </div>
        `
    },
    thumbnail: function(file, dataUrl) {
      console.log("ME ESTAN THUMBNAILIANDO", file)
      var j, len, ref, thumbnailElement
      if (file.previewElement) {
        if (file.listing == true) {
          var reff = file.previewElement.querySelectorAll("[data-dz-listing]")
          console.log("ES TRUE Y ESTE ES EL SPAN", reff)
          reff[0].style.display = "block"
        }
        file.previewElement.classList.remove("dz-file-preview")
        ref = file.previewElement.querySelectorAll("[data-dz-thumbnail-bg]")
        for (j = 0, len = ref.length; j < len; j++) {
          thumbnailElement = ref[j]
          thumbnailElement.alt = file.name
          thumbnailElement.style.backgroundImage = 'url("' + dataUrl + '")'
        }
        return setTimeout(
          (function() {
            return function() {
              return file.previewElement.classList.add("dz-image-preview")
            }
          })(this),
          1
        )
      }
    },
  },
  data() {
    const { url, videoFileTypes, photoFileTypes } = settings.dropzoneSettings
    return {
      dropzoneSettings: settings.dropzoneSettings,
      dropzoneOptions: {
        url:
          this.collectionDBname == "videos"
            ? settings.dropzoneSettings.url_videos
            : url,
        thumbnailWidth: 150,
        maxFilesize: 100,
        parallelUploads: 4,
        previewTemplate: this.template(),
        addRemoveLinks: true,
        acceptedFiles:
          this.collectionDBname == "videos" ? videoFileTypes : photoFileTypes,
      },
      isMediaSelected: false,
      selectedMedia: {},
      isLoading: false,
    }
  },
  components: {
    VueDropzone: vue2Dropzone,
    Modal,
    Loader,
  },
  computed: {
    placeHolderQuantity() {
      const quantity =
        3 -
        (this.photos && this.photos.portfolio && this.photos.portfolio.length
          ? this.photos.portfolio.length
          : 0)
      if (quantity < 1 || this.name == "portfolioVideos") {
        return 0
      } else {
        return quantity
      }
    },
  },
  watch: {
    isMediaSelected: function() {
      console.log(
        "CAMBIARON SELECCION COMO FOTO",
        this.isMediaSelected,
        this.selectedMedia
      )
      if (this.isMediaSelected) {
        document.documentElement.style.overflow = "hidden"
      } else {
        document.documentElement.style.overflow = "auto"
      }
    },
  },

  directives: {
    ClickOutside,
  },
}
</script>
<style lang="scss">
.mediacard {
  z-index: 8009;
}
#dropzone {
  background-color: rgb(255, 255, 255) !important;
  font-family: "Arial", sans-serif !important;
  letter-spacing: 0.2px !important;
  color: #777 !important;
  transition: background-color 0.2s linear !important;
  display: flex !important;
  padding: 0 !important;
  border: none;
}

#dropzone .dz-preview {
  display: inline-block !important;
  margin: 0 !important;
  background: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMOSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQogIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAwIDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KICAgIDxwYXRoIGZpbGw9IiM0NDQiIGQ9Ik03Myw1MGMwLTEyLjctMTAuMy0yMy0yMy0yM1MyNywzNy4zLDI3LDUwIE0zMC45LDUwYzAtMTAuNSw4LjUtMTkuMSwxOS4xLTE5LjFTNjkuMSwzOS41LDY5LjEsNTAiPg0KICAgICAgPGFuaW1hdGVUcmFuc2Zvcm0gDQogICAgICAgICBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIA0KICAgICAgICAgYXR0cmlidXRlVHlwZT0iWE1MIiANCiAgICAgICAgIHR5cGU9InJvdGF0ZSINCiAgICAgICAgIGR1cj0iMXMiIA0KICAgICAgICAgZnJvbT0iMCA1MCA1MCINCiAgICAgICAgIHRvPSIzNjAgNTAgNTAiIA0KICAgICAgICAgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIC8+DQogIDwvcGF0aD4NCjwvc3ZnPg==)
    no-repeat center center;
}
#dropzone .dz-progress {
  z-index: 99 !important;
}
#dropzone .dz-preview .dz-image {
  width: 100% !important;
  min-height: 24vh !important;
  height: 100% !important;
}
#dropzone .dz-preview .dz-image > div {
  width: inherit !important;
  height: inherit !important;
  background-size: cover !important;
  background-position: center !important;
  position: relative !important;
}
#dropzone .dz-preview .dz-image > img {
  width: 100% !important;
}

#dropzone .dz-preview .dz-details {
  color: rgb(0, 0, 0) !important;
  transition: opacity 0.2s linear !important;
  text-align: center !important;
}
/* #dropzone .dz-success-mark,
.dz-error-mark,
.dz-remove {
  display: none !important;
} */

#dropzone .dz-listing {
  display: none;
  position: absolute !important;
  right: 8px !important;
  bottom: 8px !important;
  font-size: 0.7rem !important;
  color: white !important;
  background-color: $accentColor !important;
  padding: 0.1rem 0.8rem !important;
  border-radius: 5px !important;
}

.vue-dropzone > .dz-preview .dz-remove {
  opacity: 0 !important;
  position: absolute;
  height: 100%;
  width: 100%;
  bottom: 0;
  margin: 0 !important;
}
.dropzone-custom-content {
  text-align: center !important;
  width: 100% !important;
  min-height: 24vh !important;
  height: 100% !important;
  border: 1.5px #d6d6d6 dashed !important ;
  display: flex !important;
  pointer-events: none;
  h3 {
    font-size: 0.9rem !important;
  }
}
.dz-message {
  order: 999 !important;
  flex: 0 0 auto !important;
  width: 33.333333% !important;
  height: 100% !important;
  padding: 2px !important;
  margin: 0 !important;
}

.media-gutters {
  padding: 2px !important;
}

.dropzone-custom-title {
  margin-top: 0 !important;
  color: #00b782 !important;
}

.subtitle {
  color: #314b5f !important;
}
</style>
